import { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { Row, Col, Typography, Button, Space, Select, Tabs } from "antd"
import { HomeOutlined } from "@ant-design/icons";
import BreadCrumb from "../BreadCrumb";
import ViewsReport from "./ViewsReport";
import CreationsReport from "./CreationsReport";
import "../../style/reporting.css"
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';

const { Title } = Typography;


const SpaceReporting = (props) => {
    const { t } = useTranslation();
    const [reportPeriod, setReportPeriod] = useState('')
    const [searchParams, setSearchParams] = useSearchParams('views');
    const { spaceId } = useParams()
    const { userInfo } = useSelector(state => state.user)
    const currentSpaceData = userInfo.spaceInfo && userInfo.spaceInfo.find(space => space.spaceId === spaceId)


    const defaultTabs = [
        {
            key: "views",
            label: t('Views'),
            children: <ViewsReport reportingPeriod={reportPeriod} />,
        },
        {
            key: "creations",
            label: t('Creations'),
            children: <CreationsReport reportingPeriod={reportPeriod} />,
        }
    ];

    // useEffect(() => {
    //     let updatedBreadItems = breadCrumbItems.map(item => {
    //         return { ...item}
    //     })
    //     setBreadCrumbItems(updatedBreadItems)
    // },[reportPeriod])

    const generateReport = () => {

    }

    const onChangeTab = (value) => {
        setSearchParams(value);
    }

    return (
        <div className="page-wrapper">
            <BreadCrumb items={[
                {
                    title: <HomeOutlined />,
                    path: userInfo.isAdmin ? "/app/dashboard" : "/app/dashboard",
                },
                {
                    title: currentSpaceData?.name,
                    path: `/app/space/${spaceId}/documents`
                },
                {
                    title: t('Reporting'),
                }
            ]} marginb="24px" />

            <Row
                gutter={8}
                style={{
                    paddingBottom: "20px"
                }}
            >
                <Col span={12}>
                    <Title level={3} style={{ margin: 0, fontSize: "20px" }} className="page-title">
                        {t('Reporting')}
                    </Title>
                </Col>
                <Col span={12} style={{ textAlign: "right" }}>
                    <Space>
                        <Select value={reportPeriod || "Select Reporting Period"} style={{ width: "200px", textAlign: "left", marginRight: "12px" }} onChange={(val) => setReportPeriod(val)}>
                            <Select.Option value="7">{t('Last 7 days')}</Select.Option>
                            <Select.Option value="30">{t('Last 30 days')}</Select.Option>
                            <Select.Option value="90">{t('Last 90 days')}</Select.Option>
                            <Select.Option value="6m">{t('Last 6 months')}</Select.Option>
                            <Select.Option value="12m">{t('Last 12 months')}</Select.Option>
                        </Select>
                        <Button type="primary" onClick={generateReport} disabled={!reportPeriod}>
                            {t('Generate Report')}
                        </Button>
                    </Space>
                </Col>
            </Row>

            <div style={{ margin: "0" }}>
                <Tabs items={defaultTabs} onChange={onChangeTab}></Tabs>
            </div>

        </div>
    )
}

export default SpaceReporting